import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-layout-right-sidebar",
  "use": "svg-icon-layout-right-sidebar-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"svg-icon-layout-right-sidebar\"><path d=\"M14.089 4.885h1.385c.764 0 1.384.62 1.384 1.385v9.236c0 .765-.619 1.385-1.384 1.385h-1.385V4.885m-1.846 12.006h-6c-.765 0-1.385-.62-1.385-1.385V6.27c0-.765.62-1.385 1.385-1.385h6v12.006\" fill=\"#CAD4D8\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol